module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1.2rem 0",
      "height": "auto"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "单位名称",
      "value": _vm.formData.danwei
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("证书生成的单位名称以此处填报的单位名称为准")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "input-align": "right",
      "label": "队伍信息",
      "rules": [{
        required: true,
        message: '请选择队伍报名记录'
      }],
      "placeholder": "请选择队伍报名记录"
    },
    on: {
      "click": function($event) {
        _vm.showBaomimgPicker = true
      }
    },
    model: {
      value: (_vm.formData.sai_baoming_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sai_baoming_name", $$v)
      },
      expression: "formData.sai_baoming_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "input-align": "right",
      "label": "项目信息",
      "rules": [{
        required: true,
        message: '请选择队伍项目'
      }],
      "placeholder": "请选择队伍项目"
    },
    on: {
      "click": function($event) {
        _vm.showBaomimgSubjectPicker = true
      }
    },
    model: {
      value: (_vm.formData.sai_baoming_subject_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sai_baoming_subject_name", $$v)
      },
      expression: "formData.sai_baoming_subject_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "input-align": "right",
      "label": "考试星级",
      "placeholder": "请选择考试星级"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('van-checkbox-group', {
    attrs: {
      "direction": "horizontal"
    },
    model: {
      value: (_vm.formData.star_type),
      callback: function($$v) {
        _vm.$set(_vm.formData, "star_type", $$v)
      },
      expression: "formData.star_type"
    }
  }, _vm._l((_vm.starList), function(item) {
    return _c('van-checkbox', {
      key: item.id,
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "name": item,
        "checked-color": "rgb(255, 173, 25)"
      }
    }, [_vm._v(_vm._s(item.text) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.province ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "省市地区",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "name": "area",
      "input-align": "right",
      "label": "本机构考官",
      "placeholder": "请选择人员"
    },
    on: {
      "click": _vm.onKaoguanShow
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("本机构考官选填")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.jigoukaoguan), function(kaoguan, index) {
    return _c('van-tag', {
      key: index,
      attrs: {
        "size": "large",
        "plain": "",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.jigoukaoguan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(kaoguan.name) + "(" + _vm._s(kaoguan.grade) + ") "), _c('a', {
      attrs: {
        "href": 'tel:' + kaoguan.phone
      }
    }, [_vm._v(_vm._s(kaoguan.phone))])])
  }), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入考级地址'
      }],
      "error-message-align": "right",
      "label": "考级地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入考级地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "name": "kaoguan",
      "label": "非机构考官",
      "readonly": "",
      "clickable": ""
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('div', {
          staticClass: "small-button",
          on: {
            "click": _vm.getKaoguanRand
          }
        }, [_vm._v(_vm._s(_vm.kaoguanWaitList.length > 0 ? '更换一波' : '随机筛选'))])]
      },
      proxy: true
    }], null, false, 514133345)
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "kaoguan-box"
  }, [_c('div', {
    staticStyle: {
      "border-top": "1px solid #eeee",
      "padding": "10px 0 10px 10px"
    }
  }, [_vm._v("已选考官名单")]), _vm._v(" "), _vm._l((_vm.formData.kaoguan), function(kaoguan, index) {
    return _c('van-tag', {
      key: index,
      attrs: {
        "size": "large",
        "plain": "",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.kaoguan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(kaoguan.name) + "(" + _vm._s(kaoguan.grade) + ") "), _c('a', {
      attrs: {
        "href": 'tel:' + kaoguan.phone
      }
    }, [_vm._v(_vm._s(kaoguan.phone))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.kaoguanWaitList.length > 0) ? _c('div', {
    staticClass: "kaoguan-box"
  }, [_c('div', {
    staticStyle: {
      "border-top": "1px solid #eeee",
      "padding": "10px 0 10px 10px"
    }
  }, [_vm._v("待选考官")]), _vm._v(" "), _vm._l((_vm.kaoguanWaitList), function(kaoguan, index) {
    return _c('van-tag', {
      key: index,
      attrs: {
        "size": "large",
        "plain": "",
        "type": "primary"
      }
    }, [_vm._v(" " + _vm._s(kaoguan.name) + "(" + _vm._s(kaoguan.grade) + ") "), _c('span', [_vm._v(_vm._s(kaoguan.phone))]), _vm._v(" "), _c('div', {
      staticClass: "small-button",
      staticStyle: {
        "margin-left": "5px"
      },
      on: {
        "click": function($event) {
          return _vm.onKaoguanChoose(kaoguan)
        }
      }
    }, [_vm._v("选择")])])
  })], 2) : _vm._e(), _vm._v(" "), (false) ? _c('van-field', {
    attrs: {
      "name": "jiandu",
      "label": "监督选择"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('div', {
          staticClass: "small-button",
          attrs: {
            "type": "default"
          },
          on: {
            "click": _vm.getJianduRand
          }
        }, [_vm._v("\n            " + _vm._s(_vm.formData.jiandu.length > 0 ? '更换一波' : '随机筛选') + "\n          ")])]
      },
      proxy: true
    }], null, false, 1422971577)
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.formData.jiandu), function(jiandu, index) {
    return _c('van-tag', {
      key: index,
      attrs: {
        "size": "large",
        "plain": "",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.jiandu.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(jiandu.name) + " "), _c('a', {
      attrs: {
        "href": 'tel:' + jiandu.phone
      }
    }, [_vm._v(_vm._s(jiandu.phone))])])
  }), 1) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入日常联系人姓名'
      }],
      "error-message-align": "right",
      "label": "联系人姓名",
      "rows": "1",
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入日常联系人姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入日常联系人电话'
      }],
      "error-message-align": "right",
      "label": "联系人电话",
      "rows": "1",
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入日常联系人电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "验证码",
      "rules": [{
        required: true,
        message: '请输入验证码'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入验证码"
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function() {
        return [_c('van-button', {
          attrs: {
            "native-type": "button",
            "size": "small",
            "type": "primary",
            "disabled": _vm.clockSecond > 0
          },
          on: {
            "click": _vm.getCode
          }
        }, [_vm._v(_vm._s(_vm.clockSecond > 0 ?
          '(' + _vm.clockSecond + 's)' : '获取验证码'))])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.formData.phonecode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phonecode", $$v)
      },
      expression: "formData.phonecode"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "label": "考级物料收货地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入考级物料收货地址"
    },
    model: {
      value: (_vm.formData.address_wuliao),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address_wuliao", $$v)
      },
      expression: "formData.address_wuliao"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存\n      ")])], 1)], 1), _vm._v(" "), _c('KaoguanPicker', {
    attrs: {
      "show": _vm.showKaoguanPicker,
      "limit": 1,
      "grade": _vm.grade,
      "defaultValue": _vm.formData.jigoukaoguan
    },
    on: {
      "onChange": _vm.onKaoguanChange,
      "onClose": function($event) {
        _vm.showKaoguanPicker = false
      },
      "onConfirm": _vm.onKaoguanConfirm
    }
  }), _vm._v(" "), _c('JianduPicker', {
    attrs: {
      "show": _vm.showJianduPicker,
      "limit": 1,
      "defaultValue": _vm.formData.jiandu
    },
    on: {
      "onChange": _vm.onJianduChange,
      "onClose": function($event) {
        _vm.showJianduPicker = false
      },
      "onConfirm": _vm.onJianduConfirm
    }
  }), _vm._v(" "), _c('CenterPicker', {
    attrs: {
      "show": _vm.showCenterPicker,
      "limit": 1,
      "defaultValue": _vm.formData.extra_center
    },
    on: {
      "onChange": _vm.onCenterChange,
      "onClose": function($event) {
        _vm.showCenterPicker = false
      },
      "onConfirm": _vm.onCenterConfirm
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showDate),
      callback: function($$v) {
        _vm.showDate = $$v
      },
      expression: "showDate"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "title": "选择年月日",
      "type": "date",
      "default-date": new Date((_vm.formData.datetitle ? _vm.formData.datetitle : "").replace(/-/g, "/")),
      "min-date": _vm.minDate
    },
    on: {
      "cancel": function($event) {
        _vm.showDate = false
      },
      "confirm": _vm.onDateConfirm
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showBaomimgPicker),
      callback: function($$v) {
        _vm.showBaomimgPicker = $$v
      },
      expression: "showBaomimgPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.saiBaomingOptions,
      "show-toolbar": "",
      "title": "报名记录选择"
    },
    on: {
      "cancel": function($event) {
        _vm.showBaomimgPicker = false
      },
      "confirm": _vm.onBaomingConfirm
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showBaomimgSubjectPicker),
      callback: function($$v) {
        _vm.showBaomimgSubjectPicker = $$v
      },
      expression: "showBaomimgSubjectPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.saiBaomingSubjectOptions,
      "show-toolbar": "",
      "title": "报名记录选择"
    },
    on: {
      "cancel": function($event) {
        _vm.showBaomimgSubjectPicker = false
      },
      "confirm": _vm.onBaomingSubjectConfirm
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01fe95d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameApplyFormSaiMine.vue
// module id = 2161
// module chunks = 0